import React from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import styles from './caroussel.module.scss';

const Caroussel = ({ images }) => {
  return (
    <Swiper
      modules={[Navigation]}
      navigation
      speed={800}
      loop
      className={styles.customswiper}
      slidesPerView={3}
    >
      {images.map((image, index) => (
        <SwiperSlide key={`slide-${index}`} className={styles.swiperslide}>
          <img src={image} alt={`Slide ${index + 1}`} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

Caroussel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Caroussel;
